import { track } from '../../../node_modules/glo-shared-js/utils/analytics';
import { getAdParams } from './utils/ad-params';

document.addEventListener('DOMContentLoaded', function() {
	const adParams = getAdParams();
	const promoAnalyticsInfo = document.getElementById('promo-analytics-info');

	if (promoAnalyticsInfo) {
		const promoTracking = JSON.parse(promoAnalyticsInfo.getAttribute('data-promo-analytics-info'));
		const promoEventName = promoTracking.eventName;

		track(promoEventName, {
			...adParams,
			promo_code: promoTracking.promo_code
		});
	}
});
